export const SINGLE_SELECT = 'single_select';
export const MULTI_SELECT = 'multi_select';
export const TEXT = 'text';
export const TEXTAREA = 'textarea';
export const ADDRESS = 'address';
export const DATETIME = 'datetime';

export const SINGLE_SELECT_DEFAULT_VALUE = null;
export const SINGLE_SELECT_EMPTY_VALUE = '__SingleSelect_Empty';

export const isSpecialPhoneField = ({ type, subType }) => type === SINGLE_SELECT && subType === TEXT;
export const isSpecialAddressField = ({ type, subType }) => {
  return type === SINGLE_SELECT && subType === ADDRESS;
}
export const isDatetimeField = ({ type }) => type === DATETIME;



// WEBPACK FOOTER //
// ./src/lib/custom-field-types.js